import React, { Component } from 'react';

import Barcode from 'react-barcode';
import { Container, Box } from "@mui/material";
import { StandardPage, StandardPageTopContent, StandardPageMainContent, MuiCol, MuiRow } from "../../components/layout";

function PalletLabel({ palletInfo }) {

  return (
    <>
    {
      palletInfo ? 
      <Container sx={{ pt: 2 }}>
        <MuiRow align_center>
          <MuiCol className="bcITF14">
            <Barcode displayValue={false} fontSize={17} width={3} height={60} margin={0} value={palletInfo.barcode} />
          </MuiCol>
        </MuiRow>
        <MuiRow align_center>
          <MuiCol className="bcITF14Text pallet">
            {palletInfo.barcode}
          </MuiCol>
        </MuiRow>
        <MuiRow>
          <MuiCol size={7}><span>Model</span></MuiCol>
          <MuiCol size={3} sx={{ textAlign: 'right' }}><span>Masterpacks</span></MuiCol>
          <MuiCol size={2} sx={{ textAlign: 'right' }}><span>Units</span></MuiCol>
        </MuiRow>
        { palletInfo.models?.sort((a, b) => b.units - a.units)?.map(model => (
          <MuiRow>
            <MuiCol size={7}><span className={"smallLabel"}>{model.name}</span></MuiCol>
            <MuiCol size={3} sx={{ textAlign: 'right' }}><span className={"smallLabel"}>{model.masterpacks}</span></MuiCol>
            <MuiCol size={2} sx={{ textAlign: 'right' }}><span className={"smallLabel"}>{model.units}</span></MuiCol>
          </MuiRow>
          ))
        }
        <MuiRow sx={{ borderTop: '1px solid black' }}>
          <MuiCol size={7}><span className={"bigInfo"}>TOTAL</span></MuiCol>
          <MuiCol size={3} sx={{ textAlign: 'right' }}><span className={"bigInfo"}>{palletInfo.totalMasterpacks ?? "N/A"}</span></MuiCol>
          <MuiCol size={2} sx={{ textAlign: 'right' }}><span className={"bigInfo"}>{palletInfo.totalUnits ?? "N/A"}</span></MuiCol>
        </MuiRow>
        {/* <MuiRow>
          <MuiCol size={3}>
            <MuiRow>
              <MuiCol sx={{paddingTop:'10px', fontWeight:"bold"}} size={1}>
                <MuiRow> UNITS</MuiRow>
                <MuiRow sx={{ marginTop: "-18px" }}> <span className="bigInfo"  >{palletInfo.totalUnits ?? "N/A"}</span></MuiRow>
              </MuiCol>
            </MuiRow>
            <MuiRow>
              <MuiCol sx={{paddingTop:'10px', fontWeight:"bold"}} size={1}>
                <MuiRow> MASTERPACKS</MuiRow>
                <MuiRow sx={{ marginTop: "-18px" }}> <span className="bigInfo"  >{palletInfo.totalMasterpacks ?? "N/A"}</span></MuiRow>
              </MuiCol>
            </MuiRow>
          </MuiCol>
          <MuiCol size={9}> 
            { palletInfo.models?.sort((a, b) => b.units - a.units)?.map(model => (
              <MuiRow>
                <MuiCol size={8}><span className={"smallLabel"}>{model.name}</span></MuiCol>
                <MuiCol size={2}><span className={"smallLabel"}>{model.units}</span></MuiCol>
              </MuiRow>
              ))}
          </MuiCol>
        </MuiRow> */}
      </Container>:
      <></>
    }
      
    </>
  );
}

export default PalletLabel;